import { useEffect } from "react";

// Расширяем типы для window.ym
declare global {
  interface Window {
    ym: (counterId: number, method: string, ...args: unknown[]) => void;
  }
}

interface YandexMetrikaConfig {
  clickmap?: boolean;
  trackLinks?: boolean;
  accurateTrackBounce?: boolean;
  webvisor?: boolean;
  trackHash?: boolean;
  ecommerce?: boolean;
}

const DEFAULT_CONFIG: YandexMetrikaConfig = {
  clickmap: true,
  trackLinks: true,
  accurateTrackBounce: true,
  webvisor: true,
  trackHash: true,
};

export const useYandexMetrika = (counterId?: number, config: YandexMetrikaConfig = DEFAULT_CONFIG) => {
  useEffect(() => {
    if (!counterId || typeof window === "undefined") {
      return;
    }

    // Проверяем, что скрипт загружен
    if (typeof window.ym !== "function") {
      console.warn("Яндекс.Метрика не загружена");
      return;
    }

    // Инициализируем счетчик
    window.ym(counterId, "init", config);

    // Отправляем первый хит
    window.ym(counterId, "hit", window.location.href);
  }, [counterId, config]);

  // Функции для отправки событий
  const reachGoal = (target: string, params?: Record<string, unknown>) => {
    if (!counterId || typeof window.ym !== "function") return;

    if (params) {
      window.ym(counterId, "reachGoal", target, params);
    } else {
      window.ym(counterId, "reachGoal", target);
    }
  };

  const hit = (url?: string, options?: Record<string, unknown>) => {
    if (!counterId || typeof window.ym !== "function") return;

    const targetUrl = url || window.location.href;
    if (options) {
      window.ym(counterId, "hit", targetUrl, options);
    } else {
      window.ym(counterId, "hit", targetUrl);
    }
  };

  const params = (parameters: Record<string, unknown>) => {
    if (!counterId || typeof window.ym !== "function") return;
    window.ym(counterId, "params", parameters);
  };

  const userParams = (parameters: Record<string, unknown>) => {
    if (!counterId || typeof window.ym !== "function") return;
    window.ym(counterId, "userParams", parameters);
  };

  return {
    reachGoal,
    hit,
    params,
    userParams,
  };
};

export default useYandexMetrika;
